module.exports = __webpack_public_path__ + "ac4a3a73ccc120d2db1b653f57efe43a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/small-palm-oil-infographic.jpg
// module id = 1778
// module chunks = 0